require.context('../images', true)
require('turbolinks').start()
require('../javascript/site')